import { Icon } from "common/Icon";
import { Msg } from "lib/localization";
import React from "react";
import { defineMessages } from "react-intl";
import styles from "./FullscreenButton.scss";

export const fullscreenMessages = defineMessages({
  exit: {
    id: "fullscreenMessages.exit",
    defaultMessage: "Exit Fullscreen",
  },
  fullscreen: {
    id: "fullscreenMessages.fullscreen",
    defaultMessage: "Fullscreen",
  },
});

export class FullscreenButton extends React.PureComponent {
  render() {
    const { isFullscreen, onClick } = this.props;

    return (
      <div className={styles.FullscreenButton}>
        <button onClick={onClick}>
          <span style={{ paddingRight: "5px" }}>
            <Icon i={isFullscreen ? "md-contract" : "md-expand"} />
          </span>
          <Msg m={isFullscreen ? fullscreenMessages.exit : fullscreenMessages.fullscreen} />
        </button>
      </div>
    );
  }
}
